import React, { lazy } from 'react';
import Loadable from 'src/components/Loadable';

const MeetTheTeamView = Loadable(
  lazy(() => import('src/pages/team/MeetTheTeamPage'))
);

const routes = [
  {
    path: 'meet-the-team',
    element: <MeetTheTeamView />
  }
];

export default routes;
